import React from "react";
import { motion } from "framer-motion";
import dashboard from "../../../../../images/web/dashboard.png";

const Dashboard: React.FC = () => {
  return (
    <section className="py-24 bg-white-f9 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold font-spartan text-black-1a leading-tight"
          >
            A{" "}
            <span className="text-blue-00 italic mx-1">dashboard</span>{" "}
            designed for your business.
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="mt-6 text-xl text-dark-6b font-inter"
          >
            Stay informed and in control with our real-time immigration case
            management tools.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative max-w-6xl mx-auto"
        >
          {/* Central Showcase Card */}
          <div className="relative rounded-[2.5rem] bg-white p-4 shadow-2xl border border-gray-100 overflow-hidden group">
            <div className="rounded-3xl overflow-hidden border border-gray-100 relative">
              <img
                src={dashboard}
                className="w-full h-auto object-cover transition-transform duration-1000 group-hover:scale-[1.02]"
                alt="SeamlessVisa Business Dashboard"
              />
              {/* Overlay gradient for depth */}
              <div className="absolute inset-0 bg-linear-to-t from-black/5 to-transparent pointer-events-none" />
            </div>

            {/* Floating UI Elements */}
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="absolute top-12 -left-12 hidden lg:flex bg-white p-5 rounded-2xl shadow-xl border border-gray-50 flex-col gap-3 min-w-[200px] z-20"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600">
                  📈
                </div>
                <div>
                  <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">
                    Growth
                  </p>
                  <p className="text-sm font-bold text-black-1a">
                    +24% Efficiency
                  </p>
                </div>
              </div>
              <div className="h-2 w-full bg-gray-100 rounded-full">
                <div className="h-full w-3/4 bg-blue-00 rounded-full" />
              </div>
            </motion.div>

            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{
                duration: 5,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1,
              }}
              className="absolute -bottom-10 -right-10 hidden lg:flex bg-blue-02 p-6 rounded-2xl shadow-2xl flex-col gap-2 min-w-[220px] z-20"
            >
              <div className="flex -space-x-3 mb-2">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 rounded-full border-2 border-blue-02 bg-gray-200 overflow-hidden"
                  >
                    <img
                      src={`https://i.pravatar.cc/100?img=${i + 10}`}
                      alt="user"
                    />
                  </div>
                ))}
              </div>
              <p className="text-white text-sm font-bold">12 Experts Online</p>
              <p className="text-blue-300 text-xs text-pretty italic line-clamp-2">
                "Your application for 'John Doe' is ready for review."
              </p>
            </motion.div>
          </div>

          {/* Background blurred glows */}
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-blue-400/10 blur-[120px] rounded-full" />
        </motion.div>
      </div>
    </section>
  );
};

export default Dashboard;
